import React from "react";
import "./CommandPanelHeaderButton.css"

type Props<T> = {
  isSelected: boolean;
  icon: React.ReactNode;
  id: T;
  onClick: (id: T) => void;
};

export default function CommandPanelHeaderButton<T>({ isSelected, icon, id, onClick }: Props<T>) {
  return (
    <div
      className="command-panel-header-button"
      onClick={() => onClick(id)}
      style={{
        background: isSelected ? "#F7A246" : "transparent",
      }}
    >
      {icon}
    </div>
  );
}
